import { map } from 'lodash';
import type { IObjectiveExitStrategy } from './ObjectiveExitStrategy.interface';
import ObjectiveApplicant from './ObjectiveApplicant';
import ObjectiveExitStrategyApplicantsProposeToRepayLoan from './ObjectiveExitStrategyApplicantsProposeToRepayLoan';

export default class ObjectiveExitStrategy implements IObjectiveExitStrategy {
  planingToRetire: Array<ObjectiveApplicant>;
  applicantsProposeToRepayLoan: ObjectiveExitStrategyApplicantsProposeToRepayLoan;

  static build = (data: IObjectiveExitStrategy) => new ObjectiveExitStrategy(data);
  static blank = () => new ObjectiveExitStrategy();

  /**
   * Constructor
   * @param {IObjectiveExitStrategy} data
   */
  constructor(data?: IObjectiveExitStrategy) {
    this.planingToRetire = map(data?.planingToRetire, (obj) => new ObjectiveApplicant(obj));
    this.applicantsProposeToRepayLoan = new ObjectiveExitStrategyApplicantsProposeToRepayLoan(
      data?.applicantsProposeToRepayLoan
    );
  }
}
